(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7135],{

/***/ 74514:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/[...sitemap]",
      function () {
        return __webpack_require__(14198);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46582);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var PageMeta = function(meta) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: meta.description
            }),
            meta.isProfile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "profile"
                    }),
                    !!meta.profileFirstName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:first_name",
                        content: meta.profileFirstName
                    }),
                    !!meta.profileLastName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:last_name",
                        content: meta.profileLastName
                    }),
                    !!meta.profileSlug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:username",
                        content: meta.profileSlug
                    }),
                    !!meta.profileGender && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:gender",
                        content: meta.profileGender
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Doctify"
            }),
            !!meta.preloadImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: meta.preloadImage
            }),
            !!meta.canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: meta.canonicalUrl,
                        hrefLang: meta.language
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: meta.canonicalUrl
                    })
                ]
            }),
            (meta === null || meta === void 0 ? void 0 : meta.noindex) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }) : null,
            !!meta.hrefLangs && meta.hrefLangs.map(function(hrefLang) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, hrefLang), "meta-hreflang-".concat(hrefLang.hreflang));
            }),
            meta.children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMeta);


/***/ }),

/***/ 14198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _sitemap_; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Link/Link.esm.js + 2 modules
var Link_esm = __webpack_require__(26025);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Tab/Tab.esm.js + 1 modules
var Tab_esm = __webpack_require__(58341);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/PaginationItem/PaginationItem.esm.js + 5 modules
var PaginationItem_esm = __webpack_require__(50044);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 2 modules
var Button_esm = __webpack_require__(77428);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Tabs/Tabs.esm.js + 8 modules
var Tabs_esm = __webpack_require__(92658);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Pagination/Pagination.esm.js + 2 modules
var Pagination_esm = __webpack_require__(4005);
;// CONCATENATED MODULE: ./components/Sitemap/styles.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var SitemapContainer = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        padding: "112px 54px 30px 54px",
        minHeight: "100vh",
        gap: "30px",
        backgroundColor: theme.palette.common.white
    }, theme.breakpoints.down("sm"), {
        gap: "24px",
        padding: "96px 16px 24px 16px"
    });
});
var NavigationsContainer = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)({
    gap: "8px",
    flexWrap: "nowrap",
    overflowX: "auto",
    maxWidth: "100%"
});
var NavigationTab = (0,styled_esm/* default */.ZP)(Button_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "active";
    }
})(function(param) {
    var theme = param.theme, active = param.active;
    return {
        border: "1px solid ".concat(theme.palette.blue[active ? 400 : 200], " !important"),
        background: "".concat(active ? theme.palette.blue[200] : theme.palette.common.white, " !important"),
        color: "".concat(theme.palette.system.navy900, " !important"),
        borderRadius: "50px",
        padding: "6px 16px",
        transition: "all 0.3s",
        fontSize: "13px",
        lineHeight: "20px",
        fontWeight: active ? 500 : 400,
        outline: "none !important",
        flexShrink: 0,
        "@media (hover: hover)": {
            "&:hover, &:active": {
                border: "1px solid ".concat(theme.palette.blue[400], " !important"),
                background: "".concat(theme.palette.blue[200], " !important")
            }
        }
    };
});
var SortingTabs = (0,styled_esm/* default */.ZP)(Tabs_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        maxWidth: "100%",
        borderTop: "1px solid ".concat(theme.palette.blue[200]),
        borderBottom: "1px solid ".concat(theme.palette.blue[200]),
        backgroundColor: "transparent",
        ".MuiTabs-flexContainer": {
            justifyContent: "space-between"
        },
        ".MuiTabs-indicator": {
            backgroundColor: theme.palette.system.navy900,
            borderRadius: "2px"
        },
        ".MuiTab-root": {
            "&.Mui-selected": {
                fontWeight: 600
            },
            minWidth: "36px",
            padding: 0,
            a: {
                width: "100%",
                lineHeight: "58px",
                fontSize: "15px",
                textDecoration: "none",
                textTransform: "uppercase",
                color: theme.palette.text.primary
            },
            "&:after": {
                background: "transparent !important"
            },
            "@media (hover: hover)": {
                "&:hover": {
                    fontWeight: 600
                }
            }
        }
    };
});
var SitemapItem = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        minHeight: "55px",
        height: "100%",
        width: "90%"
    }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
        width: "100%"
    }), _defineProperty(_obj, "a", {
        width: "inherit",
        fontSize: "13px",
        display: "block",
        color: theme.palette.text.primary,
        textDecoration: "none",
        "@media (hover: hover)": {
            "&:hover": {
                textDecoration: "underline"
            }
        }
    }), _obj;
});
var SitemapPagination = (0,styled_esm/* default */.ZP)(Pagination_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        ".MuiPaginationItem-root": {
            fontSize: "14px",
            fontWeight: 500,
            "&.Mui-disabled": {
                opacity: 1
            },
            "&.Mui-selected": {
                border: "1px solid ".concat(theme.palette.blue[200]),
                backgroundColor: "".concat(theme.palette.text.darkNavy900, " !important"),
                color: theme.palette.common.white
            }
        },
        ".MuiPagination-ul": {
            flexWrap: "nowrap",
            "li > a": {
                textDecoration: "none"
            }
        }
    };
});

// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var router = __webpack_require__(35837);
;// CONCATENATED MODULE: ./hooks/useSitemapMeta.ts


var host = "https://www.doctify.com";
var useSitemapMeta = function(param) {
    var sitemapType = param.sitemapType, keyword = param.keyword;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref = (0,router.useRouter)(), asPath = ref.asPath, locale = ref.locale;
    var canonicalUrl = "".concat(host, "/").concat(locale).concat(asPath);
    return {
        title: translate("htmlSitemap.meta.title", {
            type: keyword || translate("htmlSitemap.type.".concat(sitemapType))
        }),
        description: translate("htmlSitemap.meta.description", {
            type: keyword || translate("htmlSitemap.type.".concat(sitemapType))
        }),
        canonicalUrl: canonicalUrl
    };
};
/* harmony default export */ var hooks_useSitemapMeta = (useSitemapMeta);

// EXTERNAL MODULE: ./components/ProfileMeta.tsx
var ProfileMeta = __webpack_require__(71899);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
;// CONCATENATED MODULE: ./components/Sitemap/index.tsx
function Sitemap_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Sitemap_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var Sitemap = function(param) {
    var types = param.types, sorting = param.sorting, content = param.content, currentType = param.currentType, currentSubType = param.currentSubType, currentSorting = param.currentSorting, currentKeyword = param.currentKeyword, pagination1 = param.pagination;
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var pageMeta = hooks_useSitemapMeta({
        sitemapType: currentType,
        keyword: currentKeyword
    });
    var subTypePath = currentSubType ? "/".concat(currentSubType, "/") : "/";
    var paginationPath = currentSorting ? "".concat(currentType).concat(subTypePath).concat(currentSorting) : currentType;
    var pageSubtitle = currentKeyword ? translate("htmlSitemap.keywordLocations", {
        keyword: currentKeyword
    }) : translate("htmlSitemap.type.".concat(currentType));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SitemapContainer, {
        container: true,
        direction: "column",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMeta/* default */.Z, _objectSpread({}, pageMeta)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                container: true,
                direction: "column",
                gap: {
                    xs: "24px",
                    md: "30px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        direction: "column",
                        gap: "22px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                color: "system.navy900",
                                variant: "h1",
                                fontSize: {
                                    xs: "36px",
                                    md: "44px"
                                },
                                lineHeight: {
                                    xs: "36px",
                                    md: "56px"
                                },
                                children: translate("htmlSitemap.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationsContainer, {
                                container: true,
                                children: types.map(function(type) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationTab, {
                                        component: Link_esm/* default */.Z,
                                        href: "/".concat(locale, "/sitemap/").concat(type),
                                        active: currentType === type,
                                        variant: "outlined",
                                        children: translate("htmlSitemap.type.".concat(type))
                                    }, type);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        gap: {
                            xs: "16px",
                            md: "8px"
                        },
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                fontSize: "15px",
                                component: "h2",
                                lineHeight: {
                                    xs: "20px",
                                    md: "40px"
                                },
                                fontWeight: 500,
                                children: translate("htmlSitemap.subtitle", {
                                    type: pageSubtitle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SortingTabs, {
                                value: currentSorting,
                                variant: "scrollable",
                                children: sorting.map(function(sort, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab_esm/* default */.Z, {
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_esm/* default */.Z, {
                                            href: "/".concat(locale, "/sitemap/").concat(currentType).concat(subTypePath).concat(sort),
                                            children: sort === "other" ? "#" : sort
                                        }),
                                        value: sort
                                    }, sort + index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                        container: true,
                        children: content.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SitemapItem, {
                                container: true,
                                xs: 12,
                                sm: 6,
                                md: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_esm/* default */.Z, {
                                    href: item.url,
                                    children: Array.isArray(item.title) ? translate(item.title[0], item.title[1]) : item.title
                                })
                            }, item.url);
                        })
                    })
                ]
            }),
            pagination1.totalPages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                container: true,
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SitemapPagination, {
                    page: pagination1.page,
                    count: pagination1.totalPages,
                    hideNextButton: pagination1.page === pagination1.totalPages,
                    hidePrevButton: pagination1.page === 1,
                    renderItem: function(item) {
                        var pagination = item.page === 1 ? "" : "/page-".concat(item.page);
                        return item.page ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_esm/* default */.Z, {
                            href: "/".concat(locale, "/sitemap/").concat(paginationPath).concat(pagination),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem_esm/* default */.Z, _objectSpread({}, item))
                        }, item.page) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem_esm/* default */.Z, _objectSpread({}, item));
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var components_Sitemap = (Sitemap);

;// CONCATENATED MODULE: ./pages/sitemap/[...sitemap].tsx

var __N_SSG = true;
/* harmony default export */ var _sitemap_ = (components_Sitemap);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4005,5674,9774,2888,179], function() { return __webpack_exec__(74514); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);